import React, { PureComponent } from 'react';
import { Row, Col } from 'react-bootstrap';

class BannerAlertsList extends PureComponent {
  onPressAction = (banner) => {
    this.props.showModalHandle(banner);
  }

  render() {
    const {
      bannersList,
    } = this.props;

    return (
      <div className="alerts-container">
        <h2>Requests</h2>
        <Row className="alerts-rows-container">
          <Col sm={12}>
            {
              bannersList.length > 0
              ? 
              bannersList.map((item, index) => (
                <Row className="alert-row" key={`alert-${index}-banner`}>
                  <Col sm={12}>
                    <p>
                      {item.user.first_name} {item.user.last_name} has submitted a banner request,
                      &nbsp;
                      <span
                        onClick={() => this.onPressAction(item)}>
                        click here
                      </span>
                      &nbsp;
                      to review it.
                    </p>
                  </Col>
                </Row>
              ))
              :
              <Row className="alert-row">
                <Col sm={12}>
                  <p>
                    No banner requests.
                  </p>
                </Col>
              </Row>
            }
          </Col>
        </Row>
      </div>
    );
  }
}

export default BannerAlertsList;



// WEBPACK FOOTER //
// ./src/app/screens/dashboard/bannerAlertsList.js